import { SidenavItem } from '@konnektu/sidebar-layout';

export function createPharmaMLMenu(
  basePath: string,
  tenantBasePath?: string
): SidenavItem {
  return {
    id: 'pharma-ml',
    label: 'Pharma ML',
    icon: '@tui.brain-circuit',
    children: [
      {
        id: 'pharma-ml-speech',
        label: 'Речевая аналитика',
        icon: '@tui.audio-lines',
        children: [
          {
            id: 'pharma-ml-speech-dashboard',
            label: 'Дашборд',
            route: `${basePath}/speech-analytics/dashboard`,
            icon: '@tui.chart-no-axes-combined'
          },
          {
            id: 'pharma-ml-speech-visits',
            label: 'Визиты',
            route: `${basePath}/speech-analytics/visits`,
            icon: '@tui.list'
          },
          {
            id: 'pharma-ml-speech-scenarios',
            label: 'Сценарии',
            route: `${basePath}/speech-analytics/scenarios`,
            icon: '@tui.file-text'
          },
          {
            id: 'pharma-ml-speech-configurator',
            label: 'Конфигуратор',
            route: `${basePath}/speech-analytics/configurator`,
            icon: '@tui.sliders-horizontal'
          },
          {
            id: 'pharma-ml-speech-live',
            label: 'Онлайн',
            route: `${basePath}/speech-analytics/live`,
            icon: '@tui.radio'
          }
        ]
      },
      {
        id: 'pharma-ml-audience',
        label: 'Аналитика аудитории',
        icon: '@tui.users',
        route: `${basePath}/audience-analytics`
      },
      ...(tenantBasePath
        ? [
            {
              id: 'pharma-routes',
              label: 'Маршруты',
              icon: '@tui.map-pin',
              route: `${tenantBasePath}/pharma-routes`
            }
          ]
        : [])
    ]
  };
}
